import {useAtomValue} from 'jotai';
import {memo, useEffect, useRef} from 'react';
import toast from '@/components/HotToast';
import {nearbyInfoAtom} from '@/map/atom';
import {MAX_VISIBLE_ZOOM_METER, MESSAGES} from '@/map/constants';
import {useMapBounds, useVisibleZoomLevel} from '@/map/hooks';
import {getIntlString} from '@/utils';
import {AcademyLayer} from './AcademyLayer';
import {BusStopLayer} from './BusStopLayer';
import {DaycareCenterLayer} from './DaycareCenterLayer';
import {HomeElderlyWelfareLayer} from './HomeElderlyWelfareLayer';
import {HospitalLayer} from './HospitalLayer';
import {KindergartenLayer} from './KindergartenLayer';
// import {PublicOfficeLayer} from './PublicOfficeLayer';
import {SchoolLayer} from './SchoolLayer';
import {SubwayStationLayer} from './SubwayStationLayer';
import {UniversityLayer} from './UniversityLayer';

interface IProps {
  map: naver.maps.Map;
}

export const NearbyInfoLayer = memo(({map}: IProps) => {
  const data = useAtomValue(nearbyInfoAtom);
  const hasSelectedData = data.active && !!data.selected?.length;
  const toastId = useRef<string>();
  const isVisibleLevel = useVisibleZoomLevel(MAX_VISIBLE_ZOOM_METER.nearby_info);
  const bounds = useMapBounds(map);

  useEffect(() => {
    if (hasSelectedData && !isVisibleLevel) {
      toastId.current = toast(
        getIntlString(MESSAGES, 'area-analytics-zoom-warning', {
          type: '주변정보를',
        }),
        {duration: Infinity}
      );
    } else if (toastId?.current) {
      toast.dismiss(toastId.current);
      toastId.current = undefined;
    }
  }, [isVisibleLevel, hasSelectedData]);

  useEffect(() => {
    return () => {
      if (toastId?.current) {
        toast.dismiss(toastId.current);
        toastId.current = undefined;
      }
    };
  }, []);

  if (isVisibleLevel && data.active && bounds && map) {
    return (
      <>
        <DaycareCenterLayer bounds={bounds} map={map} />
        <KindergartenLayer bounds={bounds} map={map} />
        <SchoolLayer bounds={bounds} map={map} />
        <AcademyLayer bounds={bounds} map={map} />
        <UniversityLayer bounds={bounds} map={map} />
        <HospitalLayer bounds={bounds} map={map} />
        <HomeElderlyWelfareLayer bounds={bounds} map={map} />
        {/* 관공서 지원 중단 */}
        {/* <PublicOfficeLayer bounds={bounds} map={map} /> */}
        <SubwayStationLayer bounds={bounds} map={map} />
        <BusStopLayer bounds={bounds} map={map} />
      </>
    );
  }

  return null;
});
